var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirNotHeardRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 20,
    r: 17.5,
    stroke: "#A13636",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.242114 51.747C0.241569 52.8515 1.13656 53.7474 2.24113 53.748L20.2411 53.7568C21.3457 53.7574 22.2416 52.8624 22.2421 51.7578C22.2427 50.6532 21.3477 49.7574 20.2431 49.7568L4.2431 49.7489L4.25097 33.7489C4.25152 32.6444 3.35653 31.7485 2.25196 31.7479C1.14739 31.7474 0.251518 32.6424 0.250975 33.747L0.242114 51.747ZM22.7583 31.252L21.3448 29.837L0.828596 50.333L2.24211 51.748L3.65563 53.1629L24.1718 32.6669L22.7583 31.252Z",
    fill: "#A13636"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirNotHeardRight);
export default __webpack_public_path__ + "static/media/AirNotHeardRight.d17603796e6f341d40219f1e4c0fbc01.svg";
export { ForwardRef as ReactComponent };